'use client';

import { useInView } from 'react-intersection-observer';

type LazyComponent = {
  children: React.JSX.Element | null;
  delay?: number;
  className?: string;
};

function LazyWrap({ children, className, delay = 0 }: Readonly<LazyComponent>) {
  const intersectionOptions = {
    threshold: 0,
    triggerOnce: delay === 0,
    delay,
    trackVisibility: delay > 0,
  };
  const [componentRef, inView] = useInView(intersectionOptions);
  return (
    <div ref={componentRef} className={className}>
      {inView ? children : null}
    </div>
  );
}

export { LazyWrap };
